module.exports = __webpack_public_path__ + "static/media/co2cut-desktop.0eede474.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/co2cut-desktop.png
// module id = 218
// module chunks = 0